import _ from 'lodash'

export const allowSurvey = true

export const allowChatBot = true
export const CHAT_BOT_TYPE = 'chatBot'
export const WEB_TYPE = 'web'
export const SINGLE = 'single'
export const PAGE = 'page'

export const allowSlackBot = true
export const SLACK_BOT_TYPE = 'slackBot'

export const allowCommerce = true

export const allowNewSFUI = false

export const allowSAP = true
export const allowWorkFlow = true
export const WORKFLOW_TYPE = 'workflow'

export const allowLanding = true
export const LANDING_TYPE = 'landing'

export const allowCoBrowse = true

export const allowTitanSupportWidget = false

export const SURVEY_EMAIL_TYPE = 'surveyEmail'
export const SURVEY_TYPE = 'survey'
export const WEB_FORM_TYPE = 'web-form'
export const SF_FORM_TYPE = 'sfForm'
export const DOC_GEN_TYPE = 'docGen'
export const EDOC_GEN_TYPE = 'edocGen'
export const CLM_TYPE = 'clm'
export const SIGN_TYPE = 'sign'
export const COMMERCE_TYPE = 'commerce'
export const TITAN_FILES_TYPE = 'titanFiles'
export const TITAN_AI_CHATBOT_FEATURE_FLAG = 'FT_TITAN_42'
export const AI_SERVICE_V2 = 'AI_SERVICE_V2'
export const AI_CHAT_LIGHT_THEME = 'AI_CHAT_LIGHT_THEME' // When present, uses light theme; dark theme is default

export const PROJECT_TYPE_DISPLAY_NAMES = {
  [WEB_TYPE]: 'Titan Web',
  [WEB_FORM_TYPE]: 'Titan Forms',
  [SF_FORM_TYPE]: 'Forms',
  [DOC_GEN_TYPE]: 'Titan Docs',
  [SURVEY_TYPE]: 'Titan Survey',
  [WORKFLOW_TYPE]: 'Titan Flow',
  [CHAT_BOT_TYPE]: 'Titan Flow',
  [SLACK_BOT_TYPE]: 'Titan Flow',
  [LANDING_TYPE]: 'Titan Web',
  [CLM_TYPE]: 'Titan CLM',
  [EDOC_GEN_TYPE]: 'Titan Docs',
  [SIGN_TYPE]: 'Titan Sign',
  [COMMERCE_TYPE]: 'Titan Commerce',
  [TITAN_FILES_TYPE]: 'Titan Files'
}

export const isAllowSAP = (profile) => {
  if (!allowSAP) {
    return false
  }
  if (!profile || !profile.userID) {
    return false
  }
  return profile.isAllowSap || profile.isAdmin
}
export const isValidSubmissionLicense = (profile, projectType) => {
  if (projectType) {
    if (projectType == SF_FORM_TYPE) {
      return false
    }
  }
  if (!profile || !profile.userID) {
    return false
  }

  if (!projectType) {
    if (['v2', 'sf_mongo'].includes(profile.submissionVersion)) {
      return true
    }
  }

  if (profile.allowWeb || profile.isTrial) {
    return true
  }

  if (
    _.get(profile, ['license', 'Optimization', 'TitanWeb']) == 1 ||
    _.get(profile, ['license', 'Optimization', 'TitanForm']) == 1 ||
    _.get(profile, ['license', 'Optimization', 'TitanSurvey']) == 1 ||
    _.get(profile, ['license', 'Optimization', 'TitanFlow']) == 1
  ) {
    return true
  }

  return false
}

export const isValidProjectLicense = (project, profile) => {
  if (_.get(profile, ['allowWeb'])) {
    return true
  }
  let type = project.ProjectType || 'web'
  switch (type) {
    case 'web-form':
      if (
        _.get(profile, ['license', 'Optimization', 'TitanForm']) == 1 ||
        _.get(profile, ['license', 'Optimization', 'DocsGenerator']) == 1
      ) {
        return {
          status: true,
        }
      }
      break
    case 'surveyEmail':
    case 'survey':
      if (_.get(profile, ['license', 'Optimization', 'TitanSurvey']) == 1) {
        return {
          status: true,
        }
      }
      break
    case 'workflow':
      if (_.get(profile, ['license', 'Optimization', 'TitanFlow']) == 1) {
        return {
          status: true,
        }
      }
      break
    case 'web':
      if (
        _.get(profile, ['license', 'Optimization', 'TitanWeb']) == 1 ||
        _.get(profile, ['license', 'Optimization', 'DocsGenerator']) == 1
      ) {
        return {
          status: true,
        }
      }
      break
    default:
      if (_.get(profile, ['license', 'Optimization', 'TitanWeb']) == 1) {
        return {
          status: true,
        }
      }
      break
  }
  return {
    status: false,
  }
}

export const isAiChatbotFeatureEnabled = (profile) => {
  if (!profile || !profile?.featureFlags.includes(TITAN_AI_CHATBOT_FEATURE_FLAG)) {
    return false
  }

  return true
}
